import React from "react";

import Section from "../../Section";
import SecondaryTitle from "../../Titles/SecondaryTitle";

const Gallery = () => {
  return (
    <Section className='py-20 bg-primary-light'>
      <div className='max-w-screen-xl mx-auto px-6 lg:px-16'>

        {/* Header */}
        <div className='text-center mb-16'>
          <span className='text-accent-gold text-sm uppercase font-semibold tracking-widest'>Our Work</span>
          <SecondaryTitle
            title='Stunning Transformations'
            className='text-text-primary'
            animation='fade-up'
          />
          <div className='luxury-divider mx-auto'></div>
        </div>

        {/* Gallery Grid */}
        <div className='container mx-auto max-w-screen-lg'>
          <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4'>
            {/* Left Side Large Images */}
            <div className='col-span-2 lg:col-span-2 flex flex-col gap-4'>
              {/* Full Image 1 */}
              <img
                className='object-cover w-full h-64 lg:h-80 rounded-xl shadow-lg hover:shadow-lg-gold transition-all duration-300 cursor-pointer'
                src='./images/landing/hair1.webp'
                alt='Long Hair'
              />
              {/* Image 5 */}
              <img
                className='object-cover object-top w-full h-32 lg:h-48 rounded-xl shadow-lg hover:shadow-lg-gold transition-all duration-300 cursor-pointer'
                src='./images/landing/men.jpg'
                alt='Man'
              />
            </div>

            {/* Right Side Grid */}
            <div className='col-span-2 lg:col-span-3 flex flex-col gap-4'>
              <div className='grid grid-cols-2 lg:grid-cols-2 gap-4'>
                {/* Image 4 */}
                <img
                  className='object-cover w-full h-40 lg:h-48 rounded-xl shadow-lg hover:shadow-lg-gold transition-all duration-300 cursor-pointer'
                  src='./images/landing/hair2.webp'
                  alt='Short Hair 2'
                />
                {/* Image 3 */}
                <img
                  className='object-cover w-full h-40 lg:h-48 rounded-xl shadow-lg hover:shadow-lg-gold transition-all duration-300 cursor-pointer'
                  src='./images/landing/hair4.webp'
                  alt='Long Hair 4'
                />
              </div>
              {/* Full Height Last Image */}
              <img
                className='object-cover w-full h-48 lg:h-56 rounded-xl shadow-lg hover:shadow-lg-gold transition-all duration-300 cursor-pointer'
                src='./images/landing/hair5.webp'
                alt='Long Hair 5'
              />
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Gallery;
